import type { ReviewTileItem, SearchResult } from "@/types/tile.types";
import { TILE_SEARCH_FIELDS } from "./tile-search-match.utils";

export function fuzzyMatchScore(text: string, term: string): number {
  let termIndex = 0;
  for (let i = 0; i < text.length && termIndex < term.length; i++) {
    if (text[i] === term[termIndex]) termIndex++;
  }
  return termIndex / term.length;
}

export function findBestFuzzyMatch(
  tile: ReviewTileItem,
  searchTerm: string,
  normalizeText: (text: string) => string,
  minScore: number
): { bestScore: number; bestMatches: SearchResult["matches"] } {
  let bestScore = 0;
  let bestMatches: SearchResult["matches"] = [];

  for (const field of TILE_SEARCH_FIELDS) {
    const fieldValue = tile[field];
    if (typeof fieldValue === "string" && fieldValue) {
      const score = fuzzyMatchScore(normalizeText(fieldValue), normalizeText(searchTerm));
      if (score > bestScore && score >= minScore) {
        bestScore = score;
        bestMatches = [{ field, text: fieldValue, startIndex: 0, endIndex: fieldValue.length }];
      }
    }
  }

  return { bestScore, bestMatches };
}

export function calculateRelevanceScore(
  tileMatches: SearchResult["matches"],
  totalMatches: number,
  tile: ReviewTileItem,
  searchTerm: string,
  normalizeText: (text: string) => string
): number {
  let score = totalMatches;
  if (tile.clause != null && normalizeText(tile.clause).includes(normalizeText(searchTerm))) {
    score += 10;
  }
  tileMatches.forEach((match) => {
    if (match.startIndex === 0) score += 5;
  });
  return score;
}
